import { render } from "./LoansBalancesView.vue?vue&type=template&id=7136b45d&scoped=true"
import script from "./LoansBalancesView.vue?vue&type=script&lang=js"
export * from "./LoansBalancesView.vue?vue&type=script&lang=js"

import "./LoansBalancesView.vue?vue&type=style&index=0&id=7136b45d&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7136b45d"]])

export default __exports__